import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { FoodAlcoholFilterSettingsModel } from "../../../models/foodAndAlcohol";
import AlphabeticalFilter from '../../../common/components/alphabeticalFilter/alphabeticalFilter';

interface IProps {
  onSearchClick: any,
  totalRecordsCount: number
}

interface IState {
  foodAlcoholSettings: FoodAlcoholFilterSettingsModel,
  selectedType: null,
  selectedGroup: null,
  filterText: string
}

export class FoodAlcoholFilter extends React.Component<IProps, IState>  {
  constructor(props) {
    super(props);
    this.state = {
      foodAlcoholSettings: new FoodAlcoholFilterSettingsModel(),
      selectedType: null,
      selectedGroup: null,
      filterText: ''
    };
  }

  handleAlphaIndexChange = (letter: string) => {
    const currentSettings: FoodAlcoholFilterSettingsModel = { ...this.state.foodAlcoholSettings };
    currentSettings.foodAlcoholName = '';
    currentSettings.alphaIndex = letter;
    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      foodAlcoholSettings: { ...currentSettings },
      filterText: fiterText
    });
    this.handleSearchButtonClick(currentSettings);
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const currentSettings: FoodAlcoholFilterSettingsModel = { ...this.state.foodAlcoholSettings };
    currentSettings[name] = value;
    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      foodAlcoholSettings: { ...currentSettings },
      filterText: fiterText
    });
  }

  generateFilterText = (settings: FoodAlcoholFilterSettingsModel) => {
    let result = '';

    if (settings.alphaIndex) {
      result += "Start with <strong>'" + settings.alphaIndex + "'</strong>, "
    }
    if (settings.foodAlcoholName) {
      result += "Name <strong>'" + settings.foodAlcoholName + "'</strong>, "
    }

    return result.substr(0, result.length - 2);
  }

  handleSearchButtonClick = (settings) => {
    this.props.onSearchClick(settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      foodAlcoholSettings: new FoodAlcoholFilterSettingsModel(),
      filterText: ''
    });
    this.handleSearchButtonClick(new FoodAlcoholFilterSettingsModel());
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick(this.state.foodAlcoholSettings)
    }
  }

  render() {
    return (
      <Toolbar style={{ marginBottom: '10px' }}>
        <AlphabeticalFilter
          handleAlphaIndexChange={this.handleAlphaIndexChange}
          filters={['en', 'bg']}
        />
        <div>
          <InputText
            onKeyPress={(e) => this.handleKeyPress(e)}
            style={{ marginRight: "10px", marginBottom: "5px" }}
            name="foodAlcoholName"
            placeholder="Name"
            onChange={this.handleChange}
            value={this.state.foodAlcoholSettings && this.state.foodAlcoholSettings.foodAlcoholName ? this.state.foodAlcoholSettings.foodAlcoholName : ''}
          />
        </div>
        <div>
          <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
            Result: <strong>{this.props.totalRecordsCount}</strong>
            {this.state.filterText ? ', ' : ''}
            <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
          </div>
          <div style={{ float: "right" }}>
            <div>
              <Button
                className="p-button-raised"
                icon="pi pi-filter"
                style={{ marginRight: "10px" }}
                label="Filter"
                onClick={() => this.handleSearchButtonClick(this.state.foodAlcoholSettings)}
              />
              <Button
                className="p-button-secondary p-button-raised"
                label="Clear"
                icon="pi pi-times"
                onClick={() => this.handleClearButtonClick()}
              />
            </div>
          </div>
        </div>
      </Toolbar>
    )
  }
}

export default FoodAlcoholFilter;
